import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { local420Api } from "../api/local420Api";
import { Project_Entity } from "../../entities/project";
import { Ids } from "../../reducers/rhapsody";

const projectsAdapter = createEntityAdapter<Project_Entity>();
const initialState = projectsAdapter.getInitialState();

export const projectEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getProjects: build.query<EntityState<Project_Entity>, void>({
      query: () => `projects`,
      transformResponse: (responseData: Project_Entity[]) => {
        return projectsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["projects"],
    }),
    getProject: build.query<Project_Entity, Ids>({
      query: (arg) => {
        return {
          url: `projects/${arg.id}`,
          params: {
            sourceID: arg.sourceID,
            sourceRecordID: arg.sourceRecordID,
          },
        };
      },
      providesTags: ["projects"],
    }),
    createProject: build.mutation<Project_Entity, Partial<Project_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `projects`,
      }),
      invalidatesTags: ["projects"],
    }),
    updateProject: build.mutation<
      void,
      { id: number; body: Partial<Project_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `projects/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "projects", id },
        "projects",
      ],
    }),
    deleteProject: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `projects/${id}`,
      }),
      invalidatesTags: ["projects"],
    }),
  }),
});

export const {
  useGetProjectQuery,
  useGetProjectsQuery,
  useCreateProjectMutation,
  useDeleteProjectMutation,
  useUpdateProjectMutation,
} = projectEndpoints;

export default projectEndpoints;
